import Loadable from "@cores/loadable";

const LoadableCaptionDetail = Loadable({
    loader: () => import('./CaptionDetail'),
    loading: () => null
});

export default LoadableCaptionDetail;
